import Loading from 'components/Loading';
import * as React from 'react';
import { createBrowserRouter } from 'react-router';
import App from 'routes';

export const router = createBrowserRouter([
    // match everything with "*"
    {
        path: '*',
        element: (
            <React.Suspense fallback={<Loading />}>
                <App />
            </React.Suspense>
        ),
    },
]);
